<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
import { names } from "./api/register";
export default {
  name: "App",
  data() {
    return {
      call: "",
      packageSearch: {
        create_startdate: "",
        create_enddate: "",
        status_code: "",
        cnexpress_code: "",
        consignee_id: "",
        bing_order: "Y",
        package_trackingno: "",
        pagination: {
          pageNo: 1,
          pageSize: 10,
        },
      },
    };
  },
  created() {
    this.title();
  },
  mounted() {
    const oScript = document.createElement("script");
    oScript.type = "text/javascript";
    oScript.src = "//www.17track.net/externalcall.js";
    document.body.appendChild(oScript);
  },
  methods: {
    async title() {
      try {
        const res = await names();
        document.title = res.data.data;
      } catch (e) {
        console.log(e);
      }
    },
    _isMobile() {
      let flag = navigator.userAgent.match(
        /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
      );
      return flag;
    },
  },
};
</script>
